import { api } from "@//api";
import { queryClient } from "@/queryClient";

export const cancelBooking = async (id: string) => {
  const resp = await api.post(`/bookings/${id}/cancel`);
  queryClient.invalidateQueries(["bookings"]);

  return resp;
};
